module.exports = __webpack_public_path__ + "media/images/bolinha-cinza-83d610cfef62b38b6232b83e1cb7fbb3.svg";